import {GET_EMPLOYEE_DETAIL_INFORMATION} from "../../../enums/MyDivision/EmployeeList/EmployeeListTypes";


export const getEmployeeDetailInformationAction = (data) => {
    return {
        type: GET_EMPLOYEE_DETAIL_INFORMATION,
        payload: data,
    };
};
